import defaultApi from '@/utils/request';

export default {
  Load(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherLeaveMakeUp/Load',
      params,
    });
  },
  Get(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherLeaveMakeUp/Get',
      params,
    });
  },
  Add(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherLeaveMakeUp/Add',
      data,
    });
  },
  Update(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherLeaveMakeUp/Update',
      data,
    });
  },
  Del(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherLeaveMakeUp/Delete',
      headers: { 'Content-Type': 'application/json' },
      data,
    });
  },
  UpdateStatus(data) {
    return defaultApi({
      method: 'post',
      url: 's7x_TeacherLeaveMakeUp/UpdateStatus',
      data,
    });
  },
  GetByIdModify(params) {
    return defaultApi({
      method: 'get',
      url: 's7x_TeacherLeaveMakeUp/GetByIdModify',
      params,
    });
  },
};
